import type {ReactElement} from 'react';
import {useState} from 'react';
import {resolveChatMediaUrl} from '@Libraries/ai-chat.library';
import {MediaItemSizeType} from '@Libraries/s3-library';
import type {SurveyOptionImageProps} from './survey-option-image.types';

export function SurveyOptionImage({imageUrl, className, alt}: SurveyOptionImageProps): ReactElement | null {
  const [failedImageUrl, setFailedImageUrl] = useState<string | null>(null);

  if (failedImageUrl === imageUrl) {
    return null;
  }

  return (
    <img
      className={className}
      src={resolveChatMediaUrl(imageUrl, MediaItemSizeType.THUMB)}
      alt={alt}
      onError={(): void => {
        setFailedImageUrl(imageUrl);
      }}
    />
  );
}
